import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看更多")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看数据")
const _hoisted_7 = {
  class: "card-body",
  style: {"padding-top":"0px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "el-icon-picture-outline",
    style: {"font-size":"30px","line-height":"150px"}
  })
], -1)
const _hoisted_9 = { style: {"padding":"0 5px"} }
const _hoisted_10 = {
  key: 0,
  style: {"line-height":"25px","clear":"both"}
}
const _hoisted_11 = { style: {"float":"left","font-weight":"bold"} }
const _hoisted_12 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_13 = {
  key: 1,
  style: {"float":"right"}
}

import {MenuComponent} from '@/assets/ts/components';
import {setCurrentPageBreadcrumbs} from '@/core/helpers/breadcrumb';
import {onMounted, reactive, ref, watch} from 'vue';
import {useStore} from 'vuex';
import ApiService from '@/core/services/ApiService';
import { renderThousands } from '@/utils';
import Filter from './components/ProductFilter.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const apiUrl = 'report/product/list6';
const dataTable = ref<any[]>([
    {report_id: 10, name: '畅销款', results: [], fields: []},
    {report_id: 11, name: '潜力款', results: [], fields: []},
    {report_id: 12, name: '待优化细节款', results: [], fields: []},
    {report_id: 13, name: '待优化主图款', results: [], fields: []},
    {report_id: 14, name: '建议处理款', results: [], fields: []},
    {report_id: 15, name: '曝光不足款', results: [], fields: []},
    {report_id: 21, name: '建议降曝光款', results: [], fields: []}
]);
const filters = reactive({
    category: '',  // 类目
    params: {}, //筛选项参数，格式field: value
    weekly: '',  //周期，总共就8周
});
const loading = reactive({});

onMounted(() => {
    MenuComponent.reinitialization();
    setCurrentPageBreadcrumbs('report.product.productOverview', ['report.product.name', 'report.product.productName']);
});

// 搜索动作
const searchAction = (filter) => {
    for (let k in filter) {
        filters[k] = filter[k];
    }
    // 并发请求效率高
    dataTable.value.forEach(d => {
        loading[d['report_id']] = true;
        let ps = JSON.parse(JSON.stringify(filters));
        ps['report_id'] = d['report_id'];
        ps['params']['suggestion_action'] = d['name'];
        ApiService.get(apiUrl, ps).then(({data}) => {
            d['results'] = data.results;
            d['fields'] = data.fields;
            loading[d['report_id']] = false;
        });
    });
};

// 处理跳转传参，即把字典参数转成字符串
const filtersToString = (rid, action) => {
    let params = JSON.parse(JSON.stringify(filters));
    params['report_id'] = rid;
    params['params']['suggestion_action'] = action;
    params['params'] = JSON.stringify(params['params']);
    return params;
};
const filtersToString2 = (rid, action) => {
    let params = JSON.parse(JSON.stringify(filters));
    params['params']['suggestion_action'] = action;
    params['params'] = JSON.stringify(params['params']);
    return params;
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Filter, { onSearchAction: searchAction }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTable.value, (data) => {
      return (_openBlock(), _createElementBlock("div", {
        key: data.report_id,
        class: "card mb-5 mb-xl-10"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(data.name), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: {name: 'report.product.productList', query: filtersToString(data.report_id, data.name)},
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["to"]),
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: {name: 'report.product.productDetails', query: filtersToString2(data.report_id, data.name)},
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives((_openBlock(), _createBlock(_component_el_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data['results'], (v, i) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  key: i,
                  span: 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { "body-style": { padding: '5px', 'text-align': 'center' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {name: 'report.product.productSingle', query: {id: v.id}},
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_image, {
                              referrerpolicy: "no-referrer",
                              src: v.goods_img,
                              fit: "contain",
                              lazy: "",
                              style: {"height":"150px"}
                            }, {
                              error: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 2
                            }, 1032, ["src"])
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(v.goods_id), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data['fields'], (f) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: f.id
                            }, [
                              (f.is_display)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(f.name), 1),
                                    (f.data_type === 2 || f.data_type === 3)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(renderThousands)(v[f.field])), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(v[f.field]), 1))
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024)), [
            [_directive_loading, _unref(loading)[data.report_id]]
          ])
        ])
      ]))
    }), 128))
  ], 64))
}
}

})